import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ef-profile" }
const _hoisted_2 = { class: "ef-line" }
const _hoisted_3 = { class: "ef-line" }
const _hoisted_4 = { class: "ef-profile__infos" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-address-card" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-at" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-briefcase" }, null, -1)

import Header from '@/components/Header.vue';
import {storeUser} from "@/stores/user";
import {storeToRefs} from "pinia";
import {randomColor} from '@/functions/utils.ts';
import {useRouter} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const _storeUser = storeUser();
const {user} = storeToRefs(_storeUser);

const headerActions = [
  { icon: 'fa-solid fa-right-from-bracket', text: 'Se déconnecter', action: 'logout' },
  { icon: 'fas fa-edit', text: 'Modifier mon profile', action: 'edit' },
  { icon: 'fas fa-key', text: 'Changer mon mot de passe', action: 'changePassword' },
];

const router = useRouter();
const logout = () => {
  _storeUser.logout();
  router.push('login');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Header, {
        icone: "fa-solid fa-address-card",
        title: "Profile",
        actions: headerActions,
        onLogout: logout
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "ef-profile__logo",
        style: _normalizeStyle(`background-color: ${_unref(randomColor)(_unref(user).id)}`)
      }, _toDisplayString(_unref(user).firstname[0]) + _toDisplayString(_unref(user).lastname[0]), 5),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _hoisted_5,
          _createTextVNode(_toDisplayString(_unref(user).firstname) + " " + _toDisplayString(_unref(user).lastname), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_unref(user).email), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_7,
          _createTextVNode(" " + _toDisplayString(_unref(user).company), 1)
        ])
      ])
    ])
  ]))
}
}

})